var React = require('react');

function Person (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fill":"none","d":"M-4-4h24v24H-4V-4z","key":0}),React.createElement("path",{"fill":"#282D3D","d":"M8,2c1.1046,0,2,0.8954,2,2S9.1046,6,8,6S6,5.1046,6,4C6.0033,2.8968,6.8968,2.0033,8,2 M8,12\n\tc2.7,0,5.8,1.29,6,2H2C2.23,13.28,5.31,12,8,12 M8,0C5.7909,0,4,1.7909,4,4s1.7909,4,4,4s4-1.7909,4-4S10.2091,0,8,0z M8,10\n\tc-2.67,0-8,1.34-8,4v2h16v-2C16,11.34,10.67,10,8,10z","key":1})]);
}

Person.defaultProps = {"viewBox":"0 0 16 16"};

module.exports = Person;

Person.default = Person;
